import './Hint.css'
import * as React from 'react'

const Hint = (props:{text:string})=>(
  <div className='HintAlert'>{props.text}</div>
)

export default Hint
